import React, { useState } from "react"
import { graphql, Script } from "gatsby"
import classNames from "classnames"

const HubspotForm = ({ portalId, formId, header, subHeader, alignment }) => {
  const [loaded, setLoaded] = useState(false)

  return (
    portalId &&
    formId && (
      <div className="relative mx-auto max-w-7xl">
        <div
          className={classNames(
            alignment === "center" && "text-center",
            alignment === "left" && "text-left",
            alignment === "right" && "text-right"
          )}
        >
          {header && (
            <h2 className="mx-[15px] mt-[15px] text-darkBlue">{header}</h2>
          )}
          {subHeader && (
            <h2 className="mx-[15px] mt-[15px] text-[36px] text-darkBlue">
              {subHeader}
            </h2>
          )}
        </div>
        <div
          id={`hubspot-form${formId}`}
          className={classNames(
            alignment === "center" && "mx-auto",
            alignment === "left" && "mr-auto",
            alignment === "right" && "ml-auto",
            "mb-[30px] mt-[20px] max-w-3xl px-[18px]"
          )}
        ></div>

        <Script
          id="form-loader"
          src="https://js.hsforms.net/forms/v2.js"
          onLoad={() => setLoaded(true)}
        />
        {loaded && (
          <Script id="hubspot-form-script">
            {`
            hbspt.forms.create({
              region: "na1",
              portalId: "${portalId}",
              formId: "${formId}",
              target: "#hubspot-form${formId}"
            });
          `}
          </Script>
        )}
      </div>
    )
  )
}

export default HubspotForm

export const fragment = graphql`
  fragment HubspotForm on WpDefaultTemplate_Acf_Modules {
    ... on WpDefaultTemplate_Acf_Modules_HubspotForm {
      fieldGroupName
      header
      subHeader
      alignment
      portalId
      formId
    }
  }
`
